module.exports = __webpack_public_path__ + "static/img/1-2.c3fd5dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-2.png
// module id = 256
// module chunks = 0